import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemApiService } from "@cv-invision/core";
import { ClientIdentifierModel } from "../model/client-identifier.model";

@Injectable()
export class ClientIdentifierListService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService
	) { }

	/**
	 * Get a list of available integrations.
	 * @returns An Observable of the HTTP response containing the list of integrations.
	 */
	public getAllIntegrations(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations/list-all`
		);
	}

	/**
	 * Get a list of client identifiers by integration name.
	 * @returns An Observable of the HTTP response containing the list of client identifiers.
	 */
	public getClientIdentifiersByIntegrationName(integrationName: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers`
		);
	}

	/**
	 * Create Client Identifier
	 * @returns An Observable of the HTTP response containing the list of client identifiers.
	 */
	public createClientIdentifier(integrationName: string, clientIdentifier: ClientIdentifierModel): Observable<any> {
		return this.httpClient.post(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers`, clientIdentifier
		);
	}

	/**
	 * Update Client Identifier
	 * @returns An Observable of the HTTP response containing the list of client identifiers.
	 */
	public updateClientIdentifier(integrationName: string, clientIdentifier: ClientIdentifierModel): Observable<any> {
		return this.httpClient.put(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers/${clientIdentifier.id}`, clientIdentifier
		);
	}

	/**
	 * Delete Client Identifier
	 * @returns An Observable of the HTTP response containing the list of client identifiers.
	 */
	public deleteClientIdentifier(integrationName: string, clientIdentifier: ClientIdentifierModel): Observable<any> {
		return this.httpClient.delete(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers/${clientIdentifier.id}`
		);
	}
}
